const t = "Bước đã hoàn thành", n = "Quay lại {buttonName}", o = "Tiếp tục đến {buttonName}", e = {
  completedStep: t,
  backButton: n,
  nextButton: o
};
export {
  n as backButton,
  t as completedStep,
  e as default,
  o as nextButton
};
